import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const inviteBusinessTeamsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-invite-business-teams-modal" */ './src/ui/index').then(
			(module) => module.InviteBusinessTeamsModal,
		),
	),
	getPreloadProps: () => ({}),
});
